module.exports = __webpack_public_path__ + "img/6.ccfb5fcf.png";